var _rect, _g, _rect2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgGoogleIcon = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_10973_221617)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M18.4324 26.0836L17.7362 28.6825L15.1918 28.7363C14.4313 27.3259 14 25.7122 14 23.9973C14 22.3391 14.4033 20.7754 15.1181 19.3984H15.1187L17.384 19.8137L18.3763 22.0655C18.1686 22.671 18.0554 23.321 18.0554 23.9973C18.0555 24.7314 18.1885 25.4347 18.4324 26.0836Z",
    fill: "#FBBB00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.8242 22.1328C33.939 22.7377 33.9989 23.3625 33.9989 24.0009C33.9989 24.7169 33.9236 25.4152 33.7802 26.0889C33.2934 28.3812 32.0214 30.3828 30.2594 31.7993L30.2588 31.7987L27.4055 31.6532L27.0017 29.1323C28.1709 28.4466 29.0847 27.3735 29.566 26.0889H24.2188V22.1328H29.644H33.8242Z",
    fill: "#518EF8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.2556 31.7975L30.2562 31.798C28.5425 33.1755 26.3655 33.9996 23.9957 33.9996C20.1875 33.9996 16.8765 31.8711 15.1875 28.7387L18.4282 26.0859C19.2727 28.3398 21.4468 29.9442 23.9957 29.9442C25.0913 29.9442 26.1177 29.648 26.9985 29.131L30.2556 31.7975Z",
    fill: "#28B446"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.382 16.3022L27.1425 18.9544C26.2309 18.3846 25.1534 18.0555 23.9991 18.0555C21.3925 18.0555 19.1776 19.7335 18.3754 22.0681L15.1177 19.4011H15.1172C16.7815 16.1923 20.1342 14 23.9991 14C26.4254 14 28.6502 14.8643 30.382 16.3022Z",
    fill: "#F14336"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 47,
    height: 47,
    rx: 23.5,
    stroke: "#D1D1D1"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_10973_221617"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white",
    transform: "translate(14 14)"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgGoogleIcon, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/google-icon.63a3955b.svg";
export { ForwardRef as ReactComponent };